import { useMutation, UseMutationResult } from "react-query";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { otpApi } from "../api/otpApi";

export default function useGenerateOtp(
    options?: UseCustomMutationOptions<unknown, unknown, void>,
): UseMutationResult<unknown, unknown, void> {
    return useMutation(async () => {
        await otpApi.generate();
    }, options);
}
